import styled from 'styled-components';
import BgImg from 'assets/img/common/bg_main.jpg';

export const MainTemplate = styled.div``;

export const ContentsContainer = styled.div`
    background: url(${BgImg});
    background-size: cover;
    background-position: center;
    width: 100%;
    height: calc(100vh);
    display: flex;
    align-items: center;
    padding: 0 20px;
`;